import React from "react";
import PageLayout from "./PageLayout";
import Teachers from "../sections/Teachers";

export default function TeachersPage() {
    return (
        <PageLayout testId="teachers-page" pageTitle="Müəllim heyəti">
            <Teachers standalone />
        </PageLayout>
    );
}
